export default class {

	constructor(obj) {
		this.id = obj.analysisid
		this.analysisDate = obj.analysisDate
		this.result = obj.result
		this.parameters = obj.parameters
		this.pickupOperationId = obj.pickupid
		this.remarkCode = obj.remarkcode
		this.unit = obj.unit
		this.support = obj.support
		this.contact = obj.contact
	}
}



// WEBPACK FOOTER //
// ./src/station/dto/DtoAnalysis.js